import AppColor from "common/AppColor";
import React from "react";
import { TextFieldProps } from "./type";
import "../../styles/text-field.scss";

const TextField = ({
  placeholder,
  style,
  type = "standard",
  icon,
  onChange,
  value,
  readonly,
  textArea,
  areaRows = 3,
  invalid,
  autoFocus,
}: TextFieldProps) => {
  let body = null;
  if (textArea) {
    body = (
      <textarea
        style={styles.inputStyle}
        placeholder={placeholder}
        onChange={onChange}
        value={value || ""}
        readOnly={readonly}
        rows={areaRows}
        autoFocus={autoFocus}
      />
    );
  } else {
    body = (
      <>
        {icon && (
          <i className="material-icons" style={styles.icon}>
            {icon}
          </i>
        )}
        <input
          style={styles.inputStyle}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          readOnly={readonly}
          autoFocus={autoFocus}
        />
      </>
    );
  }
  return (
    <div
      className={`text-field ${type} ${invalid && "text-field-invalid"}`}
      style={style}
    >
      {body}
    </div>
  );
};

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    borderRadius: 4,
    border: 1,
    borderColor: AppColor.outlineInput,
    borderStyle: "solid",
  },
  inputStyle: {
    border: "none",
    outline: "none",
    flex: 1,
    width: "100%",
  },
  icon: {
    fontSize: 18,
    color: AppColor.placeholderColor,
  },
};

export default TextField;
